import apiClient from './client';
import type { Project } from '@/types/auth';

// ====================================
// Projects — vem do apisistema.conectablog.com (api-rocketads).
// Lista projetos que o user atual tem acesso (filtragem feita no backend
// via user.projects[]).
// ====================================

export const getProjects = async (): Promise<Project[]> => {
    const response = await apiClient.get<Project[] | { items: Project[] }>('/projects');
    // Algumas rotas retornam paginado {items: [...]}, outras retornam array direto.
    const data = response.data as any;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
};
